var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_18_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_18_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_18_2",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_18_2",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVR4nO3cTU7DMBCG4axg7VnQzJraoAJHpSoIymX4OQTlIAiWLUEulahYpFLiMnH9PtKsqefLjAMSrSoAAAAAAAAAAIA/3MnZlavDjWhYOPWfoqEpudxPDxau9rPYm/09MOPxsaifi4aV9aFluLWKPYq9St58p/55AAdsciin/iVpCKL+wfpQkl35eZLmx73G2gldQlgluRM2F+4AnqiQXcWLuX8AGt6sDyKZVuxdggD8h/VBJNOKvesdwK4fUhVO9t0fAmhHAMYIwBgBGCMAYwRgjACMEYBxgwhgBwIwJkwAART9pwhhAgigFyagHW9BO7CCjBsq3AEEcFB3gDABBFD0JSzDm4AvAlAC+DfCBLCCDmoFyZ6faO4AAuiHCWjHClJWUC/CHZC2QQQQeAvaxlvQDsIKStug0kjuv4jljgCMEYAxAjBGAMYIwBgBHHoA/KN26FxOw3uCAPiqAukcgn/tH0DtZ90/QOnlr/sHMDq/FA1L+8OE3GrpRqcXVQqi/n4AB2pyKleH2yqZyeTIqX+yPpRkUq72j7Fn6QL4DeGOdRTamr9cP/nJm78l7jWnfhpveF5Rw/o7gTa9mHba+dbjKoUXASgBNNZNYALUvhGsIC2zuAOUABrrJjABWvAKAgAAAAAAAAAA1aH7BiVYfmCZz30HAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.9633c9064a702e9709799d980a708b9b.svg";
export { ForwardRef as ReactComponent };